import LegalPage, { LegalSection, LegalList } from "@/components/site/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Politica de Confidențialitate"
      eyebrow="Protecția datelor"
      subtitle="Cum colectăm, folosim și protejăm datele personale ale vizitatorilor și clienților AutoRIO."
      seoDesc="Politica de confidențialitate AutoRIO — colectare, prelucrare, drepturile utilizatorului, GDPR."
      path="/politica-confidentialitate"
    >
      <LegalSection title="Introducere">
        <p>
          AutoRIO respectă confidențialitatea vizitatorilor și clienților săi.
          Această politică descrie ce date personale colectăm, în ce scop le
          utilizăm și care sunt drepturile tale conform Regulamentului
          (UE) 2016/679 — GDPR.
        </p>
        <p>
          Operator de date: <span className="text-white font-semibold">ODI MEGA TRANS S.R.L.</span>{" "}
          — CUI: RO35133743, J2015000946337, cu sediul în [adresa completă],
          reprezentată prin administratorul său.
        </p>
      </LegalSection>

      <LegalSection title="Ce date colectăm">
        <p>Putem colecta următoarele categorii de date personale:</p>
        <LegalList
          items={[
            "Date de identificare: nume, prenume.",
            "Date de contact: număr de telefon, adresă de e-mail (dacă este furnizată).",
            "Date privind cererea ta: mașina de interes, preferințe (marcă, model, buget, dotări, etc.).",
            "Date tehnice: adresa IP, tipul de browser, pagini vizitate (agregat, prin cookie-uri).",
          ]}
        />
        <p>
          Nu colectăm date sensibile (etnie, opinii politice, religie, date
          medicale etc.) și nu solicităm date financiare (card bancar, cod
          PIN) prin acest site.
        </p>
      </LegalSection>

      <LegalSection title="Scopul prelucrării">
        <p>Utilizăm datele tale personale exclusiv pentru:</p>
        <LegalList
          items={[
            "Formularea unui răspuns la solicitarea ta (ofertă, informații, programare vizionare/test drive).",
            "Intermedierea contactului cu partenerii financiari, doar dacă soliciți acest lucru.",
            "Respectarea obligațiilor legale (fiscale, contractuale, arhivare).",
            "Îmbunătățirea site-ului și a serviciilor oferite, pe bază de date agregate.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Temeiul legal">
        <p>Prelucrăm datele tale personale în baza următoarelor temeiuri:</p>
        <LegalList
          items={[
            "Consimțământul tău, exprimat prin trimiterea unei cereri sau prin acceptarea cookie-urilor.",
            "Executarea unui contract sau demersuri precontractuale, la solicitarea ta.",
            "Obligații legale ale operatorului.",
            "Interesul legitim al operatorului (îmbunătățirea serviciilor), doar în măsura în care nu prevalează drepturile tale.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Cui divulgăm datele">
        <p>
          Datele tale sunt tratate confidențial. Ele pot fi divulgate exclusiv
          către:
        </p>
        <LegalList
          items={[
            "Partenerii financiari (TBI Bank, BT Direct, UniCredit, Mogo), numai dacă soliciți o ofertă de finanțare și doar în măsura strict necesară.",
            "Autoritățile competente, în cazurile prevăzute de lege.",
            "Furnizorii de servicii tehnice (găzduire site, comunicare), sub obligații stricte de confidențialitate.",
          ]}
        />
        <p>
          Nu vindem și nu închiriem date personale către terți în scopuri de
          marketing.
        </p>
      </LegalSection>

      <LegalSection title="Perioada de stocare">
        <p>
          Păstrăm datele tale personale doar atât timp cât este necesar pentru
          scopul pentru care au fost colectate sau pentru respectarea unor
          obligații legale. Cererile care nu se materializează într-o
          tranzacție sunt șterse la solicitarea ta sau conform politicilor
          interne de retenție.
        </p>
      </LegalSection>

      <LegalSection title="Drepturile tale (GDPR)">
        <p>În calitate de persoană vizată, ai următoarele drepturi:</p>
        <LegalList
          items={[
            "Dreptul de acces la datele personale prelucrate.",
            "Dreptul la rectificarea datelor inexacte.",
            "Dreptul la ștergerea datelor („dreptul de a fi uitat”).",
            "Dreptul la restricționarea prelucrării.",
            "Dreptul la portabilitatea datelor.",
            "Dreptul de opoziție la prelucrare.",
            "Dreptul de a nu face obiectul unei decizii bazate exclusiv pe prelucrare automatizată.",
            "Dreptul de a depune plângere la Autoritatea Națională de Supraveghere (www.dataprotection.ro).",
          ]}
        />
      </LegalSection>

      <LegalSection title="Securitatea datelor">
        <p>
          Aplicăm măsuri tehnice și organizatorice rezonabile pentru
          protejarea datelor personale împotriva accesului neautorizat,
          pierderii, modificării sau divulgării.
        </p>
      </LegalSection>

      <LegalSection title="Modificări ale politicii">
        <p>
          Ne rezervăm dreptul de a actualiza această politică. Orice modificare
          semnificativă va fi comunicată prin publicarea versiunii actualizate
          pe această pagină.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Pentru orice cerere legată de datele tale personale sau exercitarea
          drepturilor GDPR, ne poți contacta la datele de pe pagina{" "}
          <a
            href="/contact"
            className="text-[#D4AF37] font-semibold hover:underline"
          >
            Contact
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
